// extracted by mini-css-extract-plugin
export default {"root":"cleans_root__Co13N","detergent":"cleans_detergent__RBVDu","table":"cleans_table__0SQ2S"};